var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"app-main",style:({
    height:_vm.$isWebsite?'auto':'100vh',
    marginTop:_vm.$isWebsite?'-50px':0
  })},[_c('keep-alive',{attrs:{"include":_vm.cachedViews}},[_c('router-view',{key:_vm.key})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }